// extracted by mini-css-extract-plugin
export var menuIcon = "_rs-0";
export var menuIconInline = "_rs-1";